export const STPD_SET_SIDEBAR = 'STPD_SET_SIDEBAR';
export const STPD_SET_VIEW = 'STPD_SET_VIEW';
export const STPD_SET_FILTERS = 'STPD_SET_FILTERS';
export const STPD_SET_FILTERS_DATA = 'STPD_SET_FILTERS_DATA';
export const STPD_SET_FILTERS_LOADING = 'STPD_SET_FILTERS_LOADING';
export const STPD_SET_DATA = 'STPD_SET_DATA';
export const STPD_SET_LOADING = 'STPD_SET_LOADING';
export const STPD_SET_MODAL_LIST = 'STPD_SET_MODAL_LIST';
export const STPD_SET_CONVERSION_BY_GROUPS = 'STPD_SET_CONVERSION_BY_GROUPS';
export const STPD_SET_CONVERSION_BY_CONVERTIBLE =
  'STPD_SET_CONVERSION_BY_CONVERTIBLE';
export const STPD_SET_FILTERS_SUMMARY = 'STPD_SET_FILTERS_SUMMARY';
